var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid-form"},[_c('fieldset',[_vm._t("title",[(_vm.title)?_c('h3',[_vm._v(_vm._s(_vm.title))]):_vm._e()]),_c('transition-group',{attrs:{"name":"transition fade-down","appear":""}},[_vm._t("default")],2)],2)])}
var staticRenderFns = []

export { render, staticRenderFns }